import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"height":"calc(100% - 54px)"} }
const _hoisted_2 = ["data", "value"]
const _hoisted_3 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_4 = {
  key: 1,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_5 = {
  key: 2,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_6 = {
  key: 3,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_7 = {
  key: 4,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_8 = {
  key: 5,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_9 = { style: 'text-align: right;' }
const _hoisted_10 = { style: {"display":"flex","font-weight":"bold","justify-content":"space-between"} }
const _hoisted_11 = { style: {"text-align":"right"} }
const _hoisted_12 = ["data", "value"]
const _hoisted_13 = { style: {"text-align":"right"} }
const _hoisted_14 = { style: {"display":"flex","font-weight":"bold","justify-content":"space-between"} }
const _hoisted_15 = { style: {"text-align":"right"} }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          color: _ctx.darkMode ? 'dark' : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('sale')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "danger",
                  fill: "outline",
                  onClickNative: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["onClickNative"])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }, 8, ["color"])
      ], undefined, true),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-padding",
      style: {"position":"relative","background-color":"var(--ion-color-white)"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_row, { style: {"margin":"0","height":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "7",
              md: "7",
              lg: "7",
              xl: "7",
              style: {"height":"100%","border-right":"1px solid #ccc"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_row, { style: {"margin":"0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_col, {
                      cols: "12",
                      sm: "12",
                      md: "12",
                      lg: "12",
                      xl: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: "item-has-value",
                              position: "floating"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('ticket_number')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              value: _ctx.ticket_number,
                              onChangeNative: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ticket_number=$event.target.value)),
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ticket_number=$event.target.value))
                            }, null, 8, ["value"])
                          ], undefined, true),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1))
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, {
                      cols: "12",
                      sm: "12",
                      md: "12",
                      lg: "12",
                      xl: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: "item-has-value",
                              position: "floating"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('zone')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              interface: "popover",
                              modelValue: _ctx.zone_id,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.zone_id) = $event)),
                              onIonChangeNative: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zone_id=$event.target.value))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_zones, (zone) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: zone.id + '_short',
                                    data: zone,
                                    value: zone.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(zone.name), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1032, ["data", "value"]))
                                }), 128))
                              ], undefined, true),
                              _: 1
                            }, 8, ["modelValue"])
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, {
                      cols: "12",
                      sm: "6",
                      md: "6",
                      lg: "6",
                      xl: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: "item-has-value",
                              position: "floating"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('entrance_date')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "date",
                              value: _ctx.entrance_date,
                              onChangeNative: _cache[4] || (_cache[4] = ($event: any) => (_ctx.entrance_date=$event.target.value)),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.entrance_date=$event.target.value))
                            }, null, 8, ["value"])
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, {
                      cols: "12",
                      sm: "6",
                      md: "6",
                      lg: "6",
                      xl: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: "item-has-value",
                              position: "floating"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('entrance_time')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "time",
                              value: _ctx.entrance_time,
                              onChangeNative: _cache[6] || (_cache[6] = ($event: any) => (_ctx.entrance_time=$event.target.value)),
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.entrance_time=$event.target.value))
                            }, null, 8, ["value"])
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, {
                      cols: "12",
                      sm: "6",
                      md: "6",
                      lg: "6",
                      xl: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: "item-has-value",
                              position: "floating"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('exit_date')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "date",
                              value: _ctx.exit_date,
                              onChangeNative: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exit_date=$event.target.value)),
                              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.exit_date=$event.target.value))
                            }, null, 8, ["value"])
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_b_col, {
                      cols: "12",
                      sm: "6",
                      md: "6",
                      lg: "6",
                      xl: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: "item-has-value",
                              position: "floating"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('exit_time')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "time",
                              value: _ctx.exit_time,
                              onChangeNative: _cache[10] || (_cache[10] = ($event: any) => (_ctx.exit_time=$event.target.value)),
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.exit_time=$event.target.value))
                            }, null, 8, ["value"])
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "5",
              md: "5",
              lg: "5",
              xl: "5",
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'pricing_' + detail.id,
                      data: detail,
                      value: detail.id
                    }, [
                      _createTextVNode(" Tarif: " + _toDisplayString(detail.name) + " ", 1),
                      (detail.early_amount > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", null, "Early bird: x" + _toDisplayString(detail.early_hours.toFixed(2)), 1),
                            _createElementVNode("div", {
                              style: _normalizeStyle('text-align: right;' + (_ctx.use_daily_max_rate ? 'text-decoration: line-through;' : ''))
                            }, _toDisplayString(detail.early_amount.toFixed(2)) + "$", 5)
                          ]))
                        : _createCommentVNode("", true),
                      (detail.late_amount > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", null, "Late bird: x" + _toDisplayString(detail.late_hours.toFixed(2)), 1),
                            _createElementVNode("div", {
                              style: _normalizeStyle('text-align: right;' + (_ctx.use_daily_max_rate ? 'text-decoration: line-through;' : ''))
                            }, _toDisplayString(detail.late_amount.toFixed(2)) + "$", 5)
                          ]))
                        : _createCommentVNode("", true),
                      (detail.normal_hours > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.t('hours')) + ": x" + _toDisplayString(detail.normal_hours.toFixed(2)), 1),
                            _createElementVNode("div", {
                              style: _normalizeStyle('text-align: right;' + (_ctx.use_daily_max_rate ? 'text-decoration: line-through;' : ''))
                            }, _toDisplayString(detail.normal_amount.toFixed(2)) + "$", 5)
                          ]))
                        : _createCommentVNode("", true),
                      (detail.normal_days > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.t('days')) + ": x" + _toDisplayString(detail.normal_days.toFixed(2)), 1),
                            _createElementVNode("div", {
                              style: _normalizeStyle('text-align: right;' + (_ctx.use_weekly_max_rate ? 'text-decoration: line-through;' : ''))
                            }, _toDisplayString(detail.normal_amount.toFixed(2)) + "$", 5)
                          ]))
                        : _createCommentVNode("", true),
                      (detail.normal_weeks > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.t('weeks')) + ": x" + _toDisplayString(detail.normal_weeks.toFixed(2)), 1),
                            _createElementVNode("div", {
                              style: _normalizeStyle('text-align: right;' + (_ctx.use_monthly_max_rate ? 'text-decoration: line-through;' : ''))
                            }, _toDisplayString(detail.normal_amount.toFixed(2)) + "$", 5)
                          ]))
                        : _createCommentVNode("", true),
                      (detail.normal_months > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.t('months')) + ": x" + _toDisplayString(detail.normal_months.toFixed(2)), 1),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(detail.normal_amount.toFixed(2)) + "$", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_2))
                  }), 128)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.t('sub_total')) + ":", 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.price.toFixed(2)) + "$", 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxes, (tax) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'tax_' + tax.type,
                      data: tax,
                      value: tax.type,
                      style: {"display":"flex","font-weight":"bold","justify-content":"space-between"}
                    }, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.t(tax.type.toUpperCase() )) + " (" + _toDisplayString((tax.rate * 100).toFixed(3)) + "%):", 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(tax.amount.toFixed(2)) + "$", 1)
                    ], 8, _hoisted_12))
                  }), 128)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.t('total_to_bill')) + ":", 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.big_total.toFixed(2)) + "$", 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    disabled: _ctx.big_total <= 0,
                    class: "btn btn-danger btn_custom",
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.openPay(_ctx.big_total, 0, 0);}),
                    style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","border":"none !important","background-color":"#39cc64","color":"white"}
                  }, _toDisplayString(_ctx.t('bill')), 9, _hoisted_16)
                ])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ], 64))
}